import React, { useEffect, useState } from 'react';
import useClubs from '../../../hooks/useClubs';
import type { ClubDTO } from '../../../model/ClubDTO';
import removeDuplicate from '../../../util/removeDuplicate';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import InternClubPaper from './InternClubPaper';
import styles from './InternCLubFinder.module.css';
import CustomCircularProgress from '../../../util/customLoadingSpinner';
import ErrorPage, { ERROR_CODE_INTERN_CLUB_FINDER_GET } from '../../../error/ErrorPage';
import { useNavigate } from 'react-router-dom';

export default function InternClubfinder() {
  const navigate = useNavigate();
  const { clubs, error, loading } = useClubs();
  const [displayedClubs, setDisplayedClubs] = useState<ClubDTO[]>([]);
  useEffect(() => {
    if (clubs) {
      setDisplayedClubs([]);
      removeDuplicate<ClubDTO>(clubs.allClubs, (a, b) => a.id === b.id).forEach((item, index) => {
        setTimeout(() => {
          setDisplayedClubs((currentItems) => [...currentItems, item]);
        }, 50 * index);
      });
    }
  }, [clubs]);
  if (loading) return <CustomCircularProgress />;
  if (error) return <ErrorPage location={ERROR_CODE_INTERN_CLUB_FINDER_GET} error={error} />;

  return (
    <div style={{ paddingBottom: '10vh' }}>
      <div className={styles.searchContainer}>
        <div className={styles.titleAndPlusContainer}>
          <h1>
            <span className={'grayText'}>Club-Finder</span>
            <span className={'whiteText'}>.</span>
          </h1>
          <IconButton
            className={styles.iconButtons}
            onClick={() => {
              navigate('/intern/newClub');
            }}
          >
            <AddIcon />
          </IconButton>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {removeDuplicate<ClubDTO>(displayedClubs, (a, b) => a.id === b.id).map((club) => {
          return (
            <div className={'fadeIn'}>
              <InternClubPaper club={club} navigate={navigate} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
